// ─────────────────────────────────────────
//  Beslut om appeals
// ─────────────────────────────────────────
// Läraren behöver se hur gruppen svarade (ordningen de skrapade) för att
// kunna sätta poäng. Försöken lagras i standardordning — samma index som
// facit och appeals — även när gruppen sett alternativen i slumpad ordning.

// Poäng efter hur många försök som behövdes: 4, 2, 1, sedan 0
const POINTS_BY_TRY = [4, 2, 1];
function pointsForTry(n) {
  return POINTS_BY_TRY[n - 1] ?? 0;
}

// Poängvalen vid godkännande och avdragen vid avslag
const APPROVE_SCORES = [4, 3, 2, 1, 0];
const REJECT_DEDUCTIONS = [0, -1, -2, -3, -4];

// Gruppens svar på frågan: skrapade alternativ i ordning, nuvarande poäng och
// ett poängförslag. Förslaget finns när appealen föreslår ett annat svar (gul):
// då är det poängen gruppen hade fått om det svaret varit rätt.
function appealContext({ result, questionIndex, correctIndex, proposedAnswer, labels }) {
  const state = result?.scratchState?.[questionIndex];
  const tries = Array.isArray(state?.attempts) ? state.attempts : [];
  const attempts = tries.map(oi => ({ oi, label: labels[oi] ?? "?", correct: oi === correctIndex }));
  const currentScore = result?.scores?.[questionIndex] ?? state?.score ?? null;

  let suggested = null;
  let suggestedTry = null;
  const proposedIndex = proposedAnswer ? labels.indexOf(String(proposedAnswer).trim().toUpperCase()) : -1;
  if (proposedIndex >= 0 && proposedIndex !== correctIndex) {
    const pos = tries.indexOf(proposedIndex);
    if (pos >= 0) { suggestedTry = pos + 1; suggested = pointsForTry(suggestedTry); }
  }
  return { attempts, currentScore, done: !!state?.done, suggested, suggestedTry, proposedIndex };
}

// Ny poäng för frågan efter ett avslag med avdrag (avdraget är ≤ 0)
function scoreAfterDeduction(currentScore, deduction) {
  return (currentScore ?? 0) + deduction;
}

// Text på ett avgjort appeal-kort. adjusted_score betyder olika saker:
// vid godkännande frågans nya poäng, vid avslag avdraget (negativt).
function decisionPoints(status, adjustedScore) {
  if (adjustedScore === null || adjustedScore === undefined) return "";
  if (status === "rejected") return adjustedScore === 0 ? "" : `${String(adjustedScore).replace("-", "−")} p`;
  return `${adjustedScore} p`;
}

export { pointsForTry, appealContext, scoreAfterDeduction, decisionPoints, APPROVE_SCORES, REJECT_DEDUCTIONS };
